/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline202,
  PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline400,
  PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline401,
  PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline404,
  PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline500,
  PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadlineMutationRequest,
  PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadlineMutationResponse,
  PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadlinePathParams,
} from "../../types/scholarshipTypeFileApprovalController/PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline.ts";
import { updateScholarshipFilesDeadlineRequestViewModelSchema } from "../updateScholarshipFilesDeadlineRequestViewModelSchema.ts";

export const putApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadlinePathParamsSchema =
  z.object({
    courseFinancialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadlinePathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline202Schema =
  z.boolean() as unknown as ToZod<PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline400Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline401Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline404Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline500Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline500>;

export const putApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadlineMutationRequestSchema =
  z.lazy(
    () => updateScholarshipFilesDeadlineRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadlineMutationRequest>;

export const putApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadlineMutationResponseSchema =
  z.lazy(
    () =>
      putApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadline202Schema,
  ) as unknown as ToZod<PutApiV1ScholarshipfileapprovalCoursefinancialpersonidFilesDeadlineMutationResponse>;
